"use client";
import { useState } from "react";
import CustomSelect from "./ui/form/CustomSelect";

type FilterBarProps = {
  setSort: (val: string | undefined) => void;
  setSearch: (val: string | undefined) => void;
  variant?: string;
};

export const FilterBar: React.FC<FilterBarProps> = ({ setSort, variant }) => {
  const options = [
    { value: "latest", label: "Latest" },
    { value: "views_count", label: "Most read" },
    { value: "likes_count", label: "Most liked" },
  ];

  const [selectedValue, setSelectedValue] = useState<string | null>(null);

  const handleSelect = (value: string) => {
    setSelectedValue(value);
    setSort(value);
  };

  if (variant === "design2") {
    return (
      <div className="w-max p-2 rounded-md mb-4 border h-max border-themeColor ml-auto">
        <CustomSelect
          options={options}
          value={selectedValue}
          onChange={setSelectedValue}
          handleSelect={handleSelect}
          placeholder="All posts"
        />
      </div>
    );
  }

  if (variant === "design3") {
  }

  return (
    <div className="flex justify-between items-center w-full p-4 rounded-lg">
      {/* Search Bar */}

      {/* Sort Dropdown */}
      <div className="flex p-2 items-center border rounded-md gap-1">
        <h6>Sort by:</h6>
        <CustomSelect
          options={options}
          value={selectedValue}
          onChange={handleSelect}
          handleSelect={handleSelect}
          placeholder="All posts"
        />
      </div>
    </div>
  );
};
